// extracted by mini-css-extract-plugin
export default {"logo":"Sidebar_logo__jh6JM"};